module.exports = __webpack_public_path__ + "img/img_left_nav_realtime_hover.71d2cdfe.svg";